declare global {
    var __DESIGNER_SMAKE_URL__: string | undefined;
}

// eslint-disable-next-line no-restricted-exports
export default defineNuxtPlugin(() => {
    const { designerSmakeUrl } = useRuntimeConfig().public;

    if (designerSmakeUrl) {
        globalThis.__DESIGNER_SMAKE_URL__ = designerSmakeUrl;
    }
});
